import React from 'react'
import { Route as RouteDom, useHistory } from 'react-router-dom'
import './Route.css'

const Route = ({ children, onlyCanvas, Screen, forceHistory, ...props }) => {
  const history = useHistory()
  if (onlyCanvas) return null
  return (
    <RouteDom {...props}>
      <div className="g-route">
        {Screen && <Screen {...forceHistory && { history } } />}
        {children}
      </div>
    </RouteDom>
  )
}

export default Route
